import React from 'react';
import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';

const CircularProgressWithCenterLabel = (props) => {
  const {
    label,
    labelProps,
    circularProgressProps
  } = props;

  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <CircularProgress variant="determinate" {...circularProgressProps} />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography variant="caption" component="div" {...labelProps}>
          {label}
        </Typography>
      </Box>
    </Box>
  );
};

export { CircularProgressWithCenterLabel };
